/**
 * Created by 1 on 2017/8/28.
 */
const TyphoonTrack = require('./typhoon/TyphoonTrack');
const TyphoonWarningLine = require('./typhoon/TyphoonWarningLine');
const TyphoonForecast = require('./typhoon/TyphoonForecast');
const BufferQuery = require('./integratedanalysis/BufferQuery');
/**
 * @namespace
 * @memberOf G
 * @alias G.biz
 * @description 通用业务包
 */
const components = {
    TyphoonTrack,
    TyphoonWarningLine,
    TyphoonForecast,
    BufferQuery
};
module.exports = components;